import React, { useState, useEffect, useCallback } from 'react';
import { supabase, POINTS } from '../lib/supabase';

const ADMIN_PASSWORD = 'tbda2025admin'; // Change this to your preferred password

export default function Admin() {
  const [authed, setAuthed] = useState(false);
  const [pw, setPw] = useState('');
  const [pwError, setPwError] = useState('');

  function login(e) {
    e.preventDefault();
    if (pw === ADMIN_PASSWORD) {
      setAuthed(true);
    } else {
      setPwError('പാസ്‌വേഡ് തെറ്റാണ്');
    }
  }

  if (!authed) {
    return (
      <div className="page-sm">
        <div className="card" style={{ maxWidth: 360, margin: '60px auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 20 }}>
            <div style={{ fontSize: 40 }}>🔐</div>
            <div style={{ fontWeight: 800, fontSize: 20, marginTop: 8 }}>അഡ്മിൻ പാനൽ</div>
            <div style={{ fontSize: 13, color: 'var(--text-3)', marginTop: 4 }}>അഡ്മിൻ ആക്‌സസ് മാത്രം</div>
          </div>
          <form onSubmit={login}>
            <div className="form-group">
              <label className="form-label">പാസ്‌വേഡ്</label>
              <input
                className="form-input"
                type="password"
                placeholder="••••••••"
                value={pw}
                onChange={e => { setPw(e.target.value); setPwError(''); }}
                autoFocus
              />
              {pwError && <div className="form-error">{pwError}</div>}
            </div>
            <button type="submit" className="btn btn-primary btn-full btn-lg">
              🔓 ലോഗിൻ
            </button>
          </form>
        </div>
      </div>
    );
  }

  return <AdminDashboard />;
}

function AdminDashboard() {
  const [tab, setTab] = useState('donors');
  const [donors, setDonors] = useState([]);
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState('');

  // Award points modal
  const [awardModal, setAwardModal] = useState(null);
  const [awardLoading, setAwardLoading] = useState(false);

  // Search
  const [search, setSearch] = useState('');

  function showToast(msg) {
    setToast(msg);
    setTimeout(() => setToast(''), 3000);
  }

  const fetchDonors = useCallback(async () => {
    setLoading(true);
    const { data } = await supabase
      .from('donors')
      .select('*')
      .order('points', { ascending: false });
    setDonors(data || []);
    setLoading(false);
  }, []);

  const fetchRequests = useCallback(async () => {
    setLoading(true);
    const { data } = await supabase
      .from('blood_requests')
      .select('*')
      .order('created_at', { ascending: false });
    setRequests(data || []);
    setLoading(false);
  }, []);

  useEffect(() => {
    if (tab === 'donors') fetchDonors();
    else fetchRequests();
  }, [tab, fetchDonors, fetchRequests]);

  async function awardPoints(donor, reason) {
    const pts = reason === 'donate' ? POINTS.DONATE : POINTS.REQUEST_FULFILLED;
    const newPoints = (donor.points || 0) + pts;
    const newCount = reason === 'donate' ? (donor.donated_count || 0) + 1 : donor.donated_count;
    const lastDonated = reason === 'donate' ? new Date().toISOString().split('T')[0] : donor.last_donated;

    setAwardLoading(true);
    const { error } = await supabase
      .from('donors')
      .update({
        points: newPoints,
        donated_count: newCount,
        last_donated: lastDonated,
        is_available: reason === 'donate' ? false : donor.is_available, // mark unavailable for 3 months after donation
      })
      .eq('id', donor.id);

    if (!error) {
      showToast(`✅ ${donor.name} — +${pts} പോയിന്റ് ചേർത്തു!`);
      setAwardModal(null);
      fetchDonors();
    } else {
      showToast('❌ Error: ' + error.message);
    }
    setAwardLoading(false);
  }

  async function toggleAvailable(donor) {
    const { error } = await supabase
      .from('donors')
      .update({ is_available: !donor.is_available })
      .eq('id', donor.id);
    if (!error) {
      showToast(`${donor.name} — ${!donor.is_available ? 'ലഭ്യം' : 'ലഭ്യമല്ല'} ആക്കി`);
      fetchDonors();
    }
  }

  async function markRequestFulfilled(id) {
    await supabase.from('blood_requests').update({ is_fulfilled: true }).eq('id', id);
    showToast('✅ അഭ്യർത്ഥന പൂർത്തിയായതായി അടയാളപ്പെടുത്തി');
    fetchRequests();
  }

  async function deleteDonor(id, name) {
    if (!window.confirm(`"${name}" — ഡിലീറ്റ് ചെയ്യണോ?`)) return;
    await supabase.from('donors').delete().eq('id', id);
    showToast(`🗑️ ${name} ഡിലീറ്റ് ചെയ്തു`);
    fetchDonors();
  }

  const filteredDonors = donors.filter(d =>
    !search || d.name?.toLowerCase().includes(search.toLowerCase()) ||
    d.phone?.includes(search) || d.blood_group?.includes(search)
  );

  return (
    <div className="page">
      {/* Toast */}
      {toast && (
        <div style={{ position: 'fixed', top: 80, left: '50%', transform: 'translateX(-50%)', background: '#1a1a2e', color: '#fff', padding: '12px 24px', borderRadius: 12, zIndex: 2000, fontWeight: 600, fontSize: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.3)' }}>
          {toast}
        </div>
      )}

      {/* Award Points Modal */}
      {awardModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div className="card" style={{ width: '100%', maxWidth: 380, position: 'relative' }}>
            <button onClick={() => setAwardModal(null)}
              style={{ position: 'absolute', top: 12, right: 12, background: 'none', border: 'none', fontSize: 20, cursor: 'pointer' }}>✕</button>
            <div style={{ fontWeight: 800, fontSize: 17, marginBottom: 4 }}>🏆 പോയിന്റ് നൽകൂ</div>
            <div style={{ fontSize: 13, color: 'var(--text-3)', marginBottom: 20 }}>
              {awardModal.name} · {awardModal.blood_group} · {awardModal.ward}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <button
                className="btn btn-primary btn-lg"
                disabled={awardLoading}
                onClick={() => awardPoints(awardModal, 'donate')}
              >
                🩸 ദാനം ചെയ്തു — +{POINTS.DONATE} പോയിന്റ്
              </button>
              <button
                className="btn btn-outline btn-lg"
                disabled={awardLoading}
                onClick={() => awardPoints(awardModal, 'fulfilled')}
              >
                🆘 അഭ്യർത്ഥന നിറവേറ്റി — +{POINTS.REQUEST_FULFILLED} പോയിന്റ്
              </button>
            </div>

            <div style={{ marginTop: 16, fontSize: 12, color: 'var(--text-3)', textAlign: 'center' }}>
              നിലവിലെ പോയിന്റ്: {awardModal.points || 0} · ദാനം: {awardModal.donated_count || 0} തവണ
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div style={{ marginBottom: 20 }}>
        <div className="section-title">🔐 അഡ്മിൻ പാനൽ</div>
        <div className="section-sub">ദാതാക്കൾ, അഭ്യർത്ഥനകൾ, പോയിന്റ് മാനേജ്മെന്റ്</div>
      </div>

      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 20 }}>
        <div className="card" style={{ textAlign: 'center', padding: '14px 8px' }}>
          <div style={{ fontSize: 22, fontWeight: 800, color: 'var(--red)' }}>{donors.length}</div>
          <div style={{ fontSize: 12, color: 'var(--text-3)' }}>ദാതാക്കൾ</div>
        </div>
        <div className="card" style={{ textAlign: 'center', padding: '14px 8px' }}>
          <div style={{ fontSize: 22, fontWeight: 800, color: 'var(--red)' }}>{requests.filter(r => !r.is_fulfilled).length}</div>
          <div style={{ fontSize: 12, color: 'var(--text-3)' }}>അഭ്യർത്ഥനകൾ</div>
        </div>
        <div className="card" style={{ textAlign: 'center', padding: '14px 8px' }}>
          <div style={{ fontSize: 22, fontWeight: 800, color: 'var(--red)' }}>{donors.reduce((s, d) => s + (d.donated_count || 0), 0)}</div>
          <div style={{ fontSize: 12, color: 'var(--text-3)' }}>മൊത്തം ദാനം</div>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <button
          className={`btn ${tab === 'donors' ? 'btn-primary' : 'btn-outline'}`}
          style={{ flex: 1 }}
          onClick={() => setTab('donors')}
        >
          👥 ദാതാക്കൾ
        </button>
        <button
          className={`btn ${tab === 'requests' ? 'btn-primary' : 'btn-outline'}`}
          style={{ flex: 1 }}
          onClick={() => setTab('requests')}
        >
          🆘 അഭ്യർത്ഥനകൾ
        </button>
      </div>

      {/* Search (donors tab) */}
      {tab === 'donors' && (
        <input
          className="filter-input"
          style={{ marginBottom: 14 }}
          type="text"
          placeholder="🔍 പേര്, ഫോൺ, ഗ്രൂപ്പ് തിരയൂ…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      )}

      {loading ? (
        <div className="loading"><div className="spinner"></div> ലോഡ് ചെയ്യുന്നു…</div>
      ) : tab === 'donors' ? (
        <div>
          {filteredDonors.length === 0 ? (
            <div className="empty-state"><div className="empty-icon">👥</div><div className="empty-title">ദാതാക്കളൊന്നുമില്ല</div></div>
          ) : filteredDonors.map(d => (
            <div key={d.id} className="card" style={{ marginBottom: 10, padding: '14px 16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                <div className="blood-badge" style={{ background: '#c0392b', minWidth: 40, height: 40, fontSize: 12 }}>{d.blood_group}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 700, fontSize: 15 }}>{d.name}</div>
                  <div style={{ fontSize: 12.5, color: 'var(--text-3)' }}>
                    📞 {d.phone} · {d.ward} · {d.age} വയസ്സ്
                  </div>
                  <div style={{ fontSize: 12, color: 'var(--text-3)', marginTop: 2 }}>
                    🏆 {d.points || 0} pts · 🩸 {d.donated_count || 0}× ദാനം · {d.is_available ? '✅ ലഭ്യം' : '⏳ ലഭ്യമല്ല'}
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
                <button
                  className="btn btn-primary btn-sm"
                  style={{ flex: 1 }}
                  onClick={() => setAwardModal(d)}
                >
                  🏆 പോയിന്റ് നൽകൂ
                </button>
                <button
                  className="btn btn-outline btn-sm"
                  onClick={() => toggleAvailable(d)}
                >
                  {d.is_available ? '⏸ ലഭ്യമല്ലാതാക്കൂ' : '▶ ലഭ്യമാക്കൂ'}
                </button>
                <button
                  className="btn btn-ghost btn-sm"
                  style={{ color: '#c0392b' }}
                  onClick={() => deleteDonor(d.id, d.name)}
                >
                  🗑
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div>
          {requests.length === 0 ? (
            <div className="empty-state"><div className="empty-icon">✅</div><div className="empty-title">അഭ്യർത്ഥനകളൊന്നുമില്ല</div></div>
          ) : requests.map(r => (
            <div key={r.id} className="card" style={{ marginBottom: 10, padding: '14px 16px', opacity: r.is_fulfilled ? 0.5 : 1 }}>
              <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', flexWrap: 'wrap' }}>
                <div className="blood-badge" style={{ background: '#c0392b' }}>{r.blood_group}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: 15 }}>{r.patient_name} {r.is_fulfilled && <span className="tag tag-green" style={{ fontSize: 11 }}>✓ പൂർത്തി</span>}</div>
                  <div style={{ fontSize: 13, color: 'var(--text-2)' }}>🏥 {r.hospital}</div>
                  <div style={{ fontSize: 12.5, color: 'var(--text-3)' }}>📞 {r.contact_phone} · 📦 {r.units_needed} units</div>
                  {r.message && <div style={{ fontSize: 12, fontStyle: 'italic', color: 'var(--text-3)', marginTop: 4 }}>{r.message}</div>}
                </div>
              </div>
              {!r.is_fulfilled && (
                <div style={{ marginTop: 10, display: 'flex', gap: 8 }}>
                  <button className="btn btn-primary btn-sm" style={{ flex: 1 }} onClick={() => markRequestFulfilled(r.id)}>
                    ✓ പൂർത്തിയായി
                  </button>
                  <button className="btn btn-ghost btn-sm" onClick={() => window.open(`tel:${r.contact_phone}`, '_self')}>
                    📞 വിളിക്കൂ
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
